import React from 'react';
import ProductPage from '../components/product-page';

export default function BscPage() {
  return (
    <ProductPage
      title="Benjamin DMX Smart Contactor"
      className="smart-power-theater"
      images={[
        {
          src: 'bsc.png',
          alt:
            'Black Enclosure with three position switch and position indicator lights',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <>
              A high amperage switch with remote on-off control using DMX or RDM
              connectivity.
            </>
          ),
        },
        {
          title: 'Features',
          id: 'features',
          content: (
            <ul>
              <li>Fully compliant with the DMX-512 and RDM standards.</li>
              <li>
                On-Off operation is provided over the DMX or RDM network using
                standard commands.
              </li>
              <li>
                The DMX address is remotely configurable using an RDM device or
                manually by use of the built-in thumbwheel switch.
              </li>
              <li>
                The position of the contactor is maintained upon loss of DMX
                communication and restoration of power.
              </li>
              <li>
                Multiple units can be configured with a time delay to
                sequentially restore to the last contactor state upon system
                power up or restoration.
              </li>
              <li>
                Local manual on-off operation is provided via a three position
                selector switch.
              </li>
              <li>Built and labeled to cUL standards.</li>
            </ul>
          ),
        },
        {
          title: 'Specifications',
          id: 'specifications',
          content: (
            <>
              <table>
                <tbody>
                  <tr>
                    <td />
                    <th>100 Amp, 3-Pole Contactor</th>
                    <th>225 Amp, 3-Pole Contactor</th>
                  </tr>
                  <tr>
                    <th>Part Number</th>
                    <td>BSC-3100</td>
                    <td>BSC-3225</td>
                  </tr>
                  <tr>
                    <th>Operational Current Rating</th>
                    <td>100A @ 480VAC</td>
                    <td>225A @ 480VAC</td>
                  </tr>
                  <tr>
                    <th>Interrupting Rating</th>
                    <td>1,150A @ 480VAC</td>
                    <td>2,500A @ 480VAC</td>
                  </tr>
                  <tr>
                    <th>Withstand Current Rating</th>
                    <td>10kA, standalone 30kA with max 350A breaker</td>
                    <td>10kA, standalone 65kA with max 350A breaker</td>
                  </tr>
                  <tr>
                    <th>Lug Sizes (AWG)</th>
                    <td>#8 to 3/0</td>
                    <td>1/0 to 350 MCM</td>
                  </tr>
                  <tr>
                    <th>Operational Voltage</th>
                    <td colspan="2">
                      <span>120/240V 1Ø 3W</span>
                      <span style={{ marginLeft: '20px' }}>
                        208Y/120V 3Ø 4W
                      </span>
                      <em>Option: 480Y/277V 3Ø 4W (consult factory)</em>
                    </td>
                  </tr>
                  <tr>
                    <th>Operational Temperature</th>
                    <td colspan="2">0°C to 60°C</td>
                  </tr>
                  <tr>
                    <th>Load Types</th>
                    <td colspan="2">
                      General Purpose, Ballast Loads, Motor Loads, and Tungsten
                      Lighting
                    </td>
                  </tr>
                  <tr>
                    <th>Auxiliary Contacts</th>
                    <td colspan="2">One Normally Open, One Normally Closed</td>
                  </tr>
                  <tr>
                    <th>Agency Rating</th>
                    <td colspan="2">UL-508A</td>
                  </tr>
                  <tr>
                    <th>Unit Weight</th>
                    <td colspan="2">36 Pounds</td>
                  </tr>
                </tbody>
              </table>
            </>
          ),
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/smart-contactor-product-sheet.pdf">
                  Product Sheet
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
